import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Menu, Search, ShoppingCart, User, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import "./Header.css";
import { Badge } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [subSidebarOpen, setSubSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSubSidebar = () => {
    setSubSidebarOpen(!subSidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    setSubSidebarOpen(false); // Close the sub-sidebar as well
  };
  const [menuOpen, setMenuOpen] = useState(false); // State to manage menu toggle
  const [isSticky, setIsSticky] = useState(false); // State to manage sticky header
  const isLoggedIn = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const savedCart = localStorage.getItem("cartItems");
  console.log(typeof savedCart);
  const parsedCart = savedCart ? JSON.parse(savedCart) : [];

  // Calculate the total quantity
  const totalQuantity = parsedCart.reduce((sum, item) => sum + item.quantity, 0);

  console.log("Total Quantity:", totalQuantity);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("role");
    alert("You have logged out successfully.");
    navigate("/login");
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggle menu state
  };
  const handleCategoryClick = (categoryName) => {
    navigate("/products", { state: { categoryName } });
  };
  // Listen to scroll events
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const languages = [
    { code: "en", label: "En" },
    { code: "kn", label: "ಕ" },
    { code: "te", label: "తె" },
    { code: "ta", label: "த" },
    { code: "hi", label: "हिं" },
  ];

  // Get stored language or default to English
  const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
  const [selectedLanguage, setSelectedLanguage] = useState(storedLanguage);

  const changeLanguage = (lang) => {
    console.log(lang);
    localStorage.setItem("selectedLanguage", lang);
    window.location.reload(); // Reload to apply changes
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div>
        {/* Main Navbar */}
        <div className={`navbar ${isSticky ? "scrolled" : ""}`}>

          <div className="menu-icon" onClick={toggleSidebar}>
            <Menu size={30} /> {/* Menu (Hamburger) Icon */}
          </div>
          <Link to={"/"}>
            <div className="logocon d-flex">
              <img
                className="logo-light"
                style={{ width: "auto", height: "11vh" }}
                src="assets/img/newlogoanimation.gif"
                alt="logo"
              />

              <div class="letter_karthik">T</div>
              <div class="letter_karthik">e</div>
              <div class="letter_karthik">r</div>
              <div class="letter_karthik">r</div>
              <div class="letter_karthik">a</div>
              <div class="letter_karthik">&nbsp;</div>
              <div class="letter_karthik">C</div>
              <div class="letter_karthik">l</div>
              <div class="letter_karthik">e</div>
              <div class="letter_karthik">n</div>
              <div class="letter_karthik">z</div>
            </div>
          </Link>

          <div className="navbar-icons">
            <select
              id="language"
              className="selectlang"
              value={selectedLanguage}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.label}
                </option>
              ))}
            </select>
            {/* <div className="icon">
                <Search size={24} />
              </div> */}
            <div className="icon">
              <Link to={"/cart"}>
                {/* {totalQuantity === 0 ? " ": <div className="cartcount">{totalQuantity}||5</div>} */}
                {/* <div className="cartcount">5</div>
                  <ShoppingCart size={24} color="black" /> */}
                <Badge badgeContent={totalQuantity} color="error">
                  <ShoppingCartOutlinedIcon Size="24" />
                </Badge>
              </Link>
            </div>
            {/* <div className="icon">
              <User size={24} />
            </div> */}
            <div className="icon">
              {isLoggedIn ? (
                <div className="nav-item" style={{ position: "relative" }} ref={dropdownRef}>
                  <button
                    onClick={toggleDropdown}
                    className="item-link nav-icon-item style1"
                    style={{ border: "none", background: "none" }}
                  >
                    <User size={24} color="black" />
                  </button>
                  {isDropdownOpen && (
                    <ul
                      style={{
                        position: "fixed",
                        right: "1%",
                        marginTop: "5px",
                        background: "#2b5887",
                        color: "white",
                        listStyle: "none",
                        padding: "10px",
                        borderRadius: "4px",
                      }}
                    >
                      {role === "admin" && (
                        <li style={{ marginBottom: "8px" }}>
                          <Link to="/admindashboard" style={{ color: "white", textDecoration: "none" }}>
                            Admin
                          </Link>
                        </li>
                      )}
                      {role === "user" && (
                        <li style={{ marginBottom: "8px" }}>
                          <Link to="/userprofile" style={{ color: "white", textDecoration: "none" }}>
                            User
                          </Link>
                        </li>
                      )}
                      <li>
                        <button
                          onClick={handleLogout}
                          style={{
                            background: "none",
                            border: "none",
                            color: "white",
                            fontFamily: "Montserrat, sans-serif",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              ) : (
                <li className="nav-item" style={{ display: "flex", alignItems: "center" }}>
                  <Link to="/login" className="item-link nav-icon-item style1" style={{ fontFamily: "Montserrat, sans-serif" }}>
                    <User size={24} color="black" />
                  </Link>
                </li>
              )}
            </div>
          </div>
          <div className="navbar-iconsmob">
            <select
              id="language"
              className="selectlang"
              value={selectedLanguage}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.label}
                </option>
              ))}
            </select><div className="d-flex">
              <div className="icon">
                <Link to={"/cart"}>
                <Badge badgeContent={totalQuantity} color="error">
                  <ShoppingCartOutlinedIcon Size="24" />
                </Badge>
                </Link>
              </div>
              <div className="icon">
                {isLoggedIn ? (
                  <div className="nav-item" style={{ position: "relative" }}>
                    <button
                      onClick={toggleDropdown}
                      className="item-link nav-icon-item style1"
                      style={{ border: "none", background: "none" }}
                    >
                      <User size={24} />
                    </button>
                    {isDropdownOpen && (
                      <ul
                        style={{
                          position: "fixed",
                          right: "1%",
                          marginTop: "5px",
                          background: "rgb(140 180 81)",
                          color: "white",
                          listStyle: "none",
                          padding: "10px",
                          borderRadius: "4px",
                        }}
                      >
                        {role === "admin" && (
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              to="/admindashboard"
                              style={{ color: "white", textDecoration: "none" }}
                            >
                              Admin
                            </Link>
                          </li>
                        )}
                        {role === "user" && (
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              to="/userprofile"
                              style={{ color: "white", textDecoration: "none" }}
                            >
                              User
                            </Link>
                          </li>
                        )}
                        <li>
                          <button
                            onClick={handleLogout}
                            style={{
                              background: "none",
                              border: "none",
                              color: "white",
                              fontFamily: "Montserrat, sans-serif",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                          >
                            Logout
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                ) : (
                  <li
                    className="nav-item"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {/* <VscAccount style={{ marginRight: "4px", fontSize: "17px", color: "white" }} /> */}
                    <Link
                      to="/login"
                      className="item-link nav-icon-item  style1"
                      style={{ fontFamily: "Montserrat, sans-serif" }}
                    >
                      <User size={24} />
                    </Link>
                  </li>
                )}
              </div>
            </div>
          </div>

        </div>

        {/* Sidebar */}
        {sidebarOpen && (
          <div className="headersidebar">
            <div className="close-btn" onClick={closeSidebar}>
              <X size={30} /> {/* Close Icon */}
            </div>
            <ul>
              <li onClick={closeSidebar}>
                <Link to={"/"}>Home</Link>
              </li>
              <hr />
              {/* <li onClick={closeSidebar}><Link to={"/"}>About Us</Link></li> */}
              <li onClick={toggleSubSidebar}>
                <p
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 0,
                    color: "black",
                    fontWeight: 700,
                  }}
                >
                  <p
                    style={{ color: "black", marginBottom: 0, fontWeight: 700 }}
                  >
                    Products
                  </p>
                  <p
                    style={{ color: "black", marginBottom: 0, fontWeight: 700 }}
                  >
                    <FaAngleRight />
                  </p>
                </p>
              </li>
              <hr />
              <li onClick={closeSidebar}>
                <Link to={"/"}>Blog</Link>
              </li>
              <hr />
              <li onClick={closeSidebar}>
                <Link to={"/contactus"}>Contact Us</Link>
              </li>
              <hr />
            </ul>

            {/* Sub Sidebar for Products */}
            {subSidebarOpen && (
              <div className="sub-sidebar">
                <ul>
                  <li onClick={closeSidebar}>
                    <Link to={"/products"}>All Products</Link>
                  </li>
                  <li onClick={closeSidebar}>
                    <a onClick={() => handleCategoryClick("Copper Nano")}>
                      Copper Nano
                    </a>
                  </li>
                  <li onClick={closeSidebar}>
                    <a onClick={() => handleCategoryClick("Silver Nano")}>
                      Silver Nano
                    </a>
                  </li>
                  <li onClick={closeSidebar}>
                    <a onClick={() => handleCategoryClick("Hospital Products")}>
                      Hospital Products
                    </a>
                  </li>
                  <li onClick={closeSidebar}>
                    <a onClick={() => handleCategoryClick("Other Products ")}>
                      Other Products
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
